<script lang="ts">
//
  import type { Chat } from "../lib/types";

  export let chats: Chat[];

  const formatTime = (timestamp?: string): string => {
    if (!timestamp) return "";

    const date = new Date(timestamp);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) return "now";
    if (minutes < 60) return `${minutes}m`;
    if (hours < 24) return `${hours}h`;
    if (days === 1) return "yesterday";
    if (days < 7) return `${days}d`;
    return date.toLocaleDateString();
  };
</script>

<div class="chat-list">
  <div class="chats">
    {#each chats as chat}
      <a href="#{chat.uuid}" class="chat">
        <img src={chat.avatar_url} alt={chat.name} />
        <div class="info">
          <div class="top">
            <span class="name">{chat.name}</span>
            {#if chat.last_activity}
              <span class="time">{formatTime(chat.last_activity)}</span>
            {/if}
          </div>
          <div class="bottom">
            <div class="spacer"></div>
            {#if chat.unread_count > 0}
              <span class="unread">{chat.unread_count}</span>
            {/if}
          </div>
        </div>
      </a>
    {/each}

    {#if chats.length === 0}
      <div class="empty">
        <p>No chats available</p>
      </div>
    {/if}
  </div>
</div>

<style>
.chat-list {
  height: 100%;
  background: white;
}

.chats {
  overflow-y: auto;
  height: 100%;
}

.chat {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #f5f5f5;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.2s;
}

.chat:hover {
  background: #f8f9fa;
}

img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 1rem;
  flex-shrink: 0;
}

.info {
  flex: 1;
  min-width: 0;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
}

.time {
  font-size: 0.8rem;
  color: #666;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.spacer {
  flex: 1;
}

.unread {
  background: #007bff;
  color: white;
  border-radius: 10px;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  font-weight: 600;
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
}
</style>
